import {notification} from 'antd';
import {EmailPreviewT} from '../types/codes';
import {printHtmlAsPdf} from '../helpers/pdf';
import {copyHtmlToClipboard} from '../helpers/clipboard';

export const useEmailPreviewActions = (emailData: EmailPreviewT) => {
  const handleCopyEmail = async () => {
    try {
      const emailBody = emailData.emailBody || '';
      await copyHtmlToClipboard(emailBody);

      notification.success({
        message: 'Email copied. Now you can paste it in your email and send to the guest.',
        placement: 'topRight',
        duration: 3,
      });
    } catch (error) {
      console.error('Failed to copy email:', error);
      notification.error({
        message: 'Failed to copy email',
        placement: 'topRight',
        duration: 2,
      });
    }
  };

  const handleSavePDF = () => {
    try {
      const emailBody = emailData.emailBody || '';

      // Show notification immediately
      notification.success({
        message: 'Email PDF downloading. Now you can add it in your email and send to the guest.',
        placement: 'topRight',
        duration: 3,
      });

      printHtmlAsPdf(emailBody);
    } catch (error) {
      console.error('Failed to save PDF:', error);
      const errorMessage = error instanceof Error ? error.message : 'Failed to save PDF';
      notification.error({
        message: errorMessage,
        placement: 'topRight',
        duration: 2,
      });
    }
  };

  return {
    handleCopyEmail,
    handleSavePDF,
  };
};
